import client from '@/apis/client';
import type { Response } from '@/types/client.types';
import type {
  EnergyUsageAnalysisData,
  PostEnergyUsageAnalysisRequest,
} from '@/types/report/energyUsageAnalysis.types';

// Task 6: 에너지사용량 분석 API

export const getEnergyUsageAnalysis = (inspectionAreaId: number) =>
  client
    .get<Response<EnergyUsageAnalysisData | null>>('/report/energy-usage', {
      params: { inspectionAreaId },
    })
    .then((res) => res.data)
    .catch((error) => {
      console.error('Error fetching energy usage analysis:', error);
      throw error;
    });

export const postEnergyUsageAnalysis = (
  body: PostEnergyUsageAnalysisRequest
) =>
  client
    .post<Response<null>>('/report/energy-usage/upload', body)
    .then((res) => res.data)
    .catch((error) => {
      console.error('Error posting energy usage analysis:', error);
      throw error;
    });
